/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FORM from 'common/consts/form';
import { inject, observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';
import CustomButton from './CustomButton';

const isDisabled = buttonState => !!buttonState;

@inject('coreStore')
@observer
class SubmitButton extends Component {
  @Bind()
  getButtonMessage = (buttonState) => {
    const {
      coreStore: {
        translations,
      },
    } = this.props;

    switch (buttonState) {
    case FORM.BUTTON_STATE.SUCCESS:
      return translations.FORM_BUTTON_SUCCESS_MESSAGE;
    case FORM.BUTTON_STATE.ERROR:
      return translations.FORM_BUTTON_ERROR_MESSAGE;
    case FORM.BUTTON_STATE.LOADING:
      return translations.FORM_BUTTON_LOADING_MESSAGE;
    default:
      return translations.FORM_BUTTON_DEFAULT_MESSAGE;
    }
  };

  render() {
    const {
      centered,
      buttonState,
    } = this.props;
    return (
      <CustomButton
        centered={centered}
        disabled={isDisabled(buttonState)}
        type="submit"
      >
        {this.getButtonMessage(buttonState)}
      </CustomButton>
    );
  }
}

SubmitButton.propTypes = {
  centered: PropTypes.bool,
  buttonState: PropTypes.string,
};
SubmitButton.defaultProps = {
  centered: false,
  buttonState: '',
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/blocks/Form/SubmitButton.jsx